import "lightgallery.js";

let images = document.querySelectorAll('.wp-block-image');
for (let i = 0; i < images.length; i++) {
  const link = images[i].querySelector('a');
  if(!link) {
    continue;
  }
  if(!/\.(?:jpg|jpeg|gif|png)$/i.test(link.href)) {
    continue;
  }
  var gallery = lightGallery(images[i], {
    selector: "a"
  });
}
